import {GrowthBook} from "@growthbook/growthbook";
import environment from "../constants/environments";

export const growthbook = new GrowthBook({
  apiHost: environment.REACT_APP_GROWTHBOOK_API_HOST,
  clientKey: environment.REACT_APP_GROWTHBOOK_CLIENT_KEY,
  enableDevMode: true,
  subscribeToChanges: true,
});

export const syncGrowthBookAttributes = () => {
  const healthCoachIdFromStorage = localStorage.getItem("health_coach_id");
  let userInfo: {health_coach_id?: string} = {};

  try {
    userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
  } catch {
    userInfo = {};
  }

  const healthCoachId = healthCoachIdFromStorage || userInfo?.health_coach_id;
  if (!healthCoachId) {
    return;
  }

  growthbook.setAttributes({
    id: healthCoachId,
    healthCoachId,
  });
};
